import bbox from "@turf/bbox";

import { lineString } from "@turf/helpers";
import { last } from "lodash";
import mapboxgl from "mapbox-gl";
import React, { useEffect, useRef, useState } from "react";
import { Layer, Map as ReactMap, Source } from "react-map-gl";
import { Composition, continueRender, delayRender } from "remotion";
import { getGeocodes } from "utils/getters";
import "./TripReel.scss";
import currentTripJSON from "./currentTrip.json";
import ImageMarker from "./imagemarker/ImageMarker";
import reelDataJSON from "./reelData.json";
mapboxgl.accessToken = "pk.eyJ1Ijoib21hcnMiLCJhIjoiY2w0NDN3OHRvMDAxazNkcXRzcG1kMmpyMCJ9.l6IL4HDt1K5dfcDAFnp-vg";

const CompositionComponent = ({ currentTrip, reelData }) => {
  const mapRef = useRef(null);
  const rendered = useRef(false);
  const [handle] = useState(() => delayRender("Loading map..."));
  // const frame = useCurrentFrame();
  // const ref = useRef<HTMLDivElement>(null);
  // const [bound, setBound] = useState({});
  // useEffect(() => {
  //   const viewport = new WebMercatorViewport({ width: 3510, height: 2490 });
  //   const polygon = lineString(currentTrip?.destinations?.map(getGeocodes));
  //   const [minLng, minLat, maxLng, maxLat] = bbox(polygon);
  //   const bound = viewport.fitBounds(
  //     [
  //       [minLng, minLat],
  //       [maxLng, maxLat],
  //     ],
  //     { padding: 20, offset: [0, -40] }
  //   );
  //   console.log(bound);
  //   setBound(bound);
  //   setViewState({
  //     longitude: bound?.longitude,
  //     latitude: bound?.latitude,
  //   });
  // }, []);

  // const [viewState, setViewState] = useState({
  //   longitude: 0,
  //   latitude: 0,
  // });

  // console.log(viewState);
  // console.log(bound.zoom);

  // const { fps } = useVideoConfig();
  // const [handle] = useState(() => delayRender("Loading map..."));
  // const map = mapRef?.current?.getMap();

  const paths = reelData?.map((item) => ((item?.path?.length ?? 0) >= 2 ? lineString(item.path) : null));

  const markerLocations = reelData?.map((item, index) => {
    const destination = currentTrip?.destinations?.[index];
    let coords: [number, number] | null = null;
    if (item?.path?.length > 0) {
      coords = item.path[0];
    } else {
      const prevPath = reelData?.[index - 1]?.path;
      const prevEnd = Array.isArray(prevPath) && prevPath.length > 0 ? last(prevPath) : null;
      if (prevEnd) {
        coords = prevEnd as [number, number];
      } else if (destination?.longitude != null && destination?.latitude != null) {
        coords = [destination.longitude, destination.latitude];
      }
    }
    if (!coords) return null;
    return { image: item?.photos?.[0], lng: coords[0], lat: coords[1] };
  });

  const fitToDestinations = () => {
    const destinations = currentTrip?.destinations;
    if (!destinations?.length || !mapRef.current) return;

    const coords: [number, number][] = destinations
      .map(getGeocodes)
      .filter((c): c is [number, number] => Array.isArray(c) && c.length === 2 && Number.isFinite(c[0]) && Number.isFinite(c[1]));

    if (coords.length === 0) return;

    if (coords.length === 1) {
      mapRef.current.getMap().jumpTo({ center: coords[0], zoom: 8 });
    } else {
      const polygon = lineString(coords);
      const [minLng, minLat, maxLng, maxLat] = bbox(polygon);
      mapRef.current.fitBounds(
        [[minLng, minLat], [maxLng, maxLat]],
        { padding: 400, duration: 0 }
      );
    }

    if (!rendered.current) {
      rendered.current = true;
      setTimeout(() => {
        continueRender(handle);
      }, 5000);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fitToDestinations();
      setTimeout(() => {
        if (!rendered.current) {
          rendered.current = true;
          continueRender(handle);
        }
      }, 8000);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  const paint = {
    "line-color": "#FFFFFF",
    "line-opacity": 1,
    "line-width": 8,
  };

  return (
    <>
      <ReactMap
        // {...viewState}
        ref={mapRef}
        mapStyle="mapbox://styles/omars/cm232jalo005601pgal7x1emq"
        //@ts-ignore
        projection="mercator"
        style={{ height: "100%", width: "100%" }}
        mapboxAccessToken="pk.eyJ1Ijoib21hcnMiLCJhIjoiY2w0NDN3OHRvMDAxazNkcXRzcG1kMmpyMCJ9.l6IL4HDt1K5dfcDAFnp-vg"
        attributionControl={false}
        onIdle={fitToDestinations}
      >
        {paths?.map((path, index) => (
          <Source id={`source-${index}`} type="geojson" data={path} lineMetrics={true}>
            <Layer id={`line-${index}`} type="line" source={`source-${index}`} paint={paint} />
          </Source>
        ))}

        {markerLocations?.filter(Boolean).map((marker, index) => (
          <ImageMarker key={index} destination={marker!} />
        ))}
      </ReactMap>
    </>
  );
};

const MapImage: React.FC = () => {
  const currentTrip = currentTripJSON;
  const reelData = reelDataJSON;
  return (
    <Composition
      //@ts-ignore
      component={CompositionComponent}
      fps={30}
      durationInFrames={201}
      id="reel"
      width={3510}
      height={2490}
      defaultProps={{ currentTrip, reelData }}
    />
  );
};

export default MapImage;
